import api from '@/lib/api';

export interface LoginRequest {
  usernameOrEmailOrPhone: string;
  password: string;
}

export interface SetupStatusResponse {
  status: string;
  data?: {
    needSetup: boolean;
  };
  message?: string;
}

export interface InitialAdminRequest {
  username: string;
  email: string;
  name: string;
  password: string;
}

export interface LoginResponse {
  status: string;
  data?: {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    admin: {
      id: string;
      username: string;
      email: string;
      name: string;
      role: string;
      isActive: boolean;
      createdAt: string;
      updatedAt: string;
    };
  };
  message?: string;
}

export interface AdminUser {
  id: string;
  username: string;
  email: string;
  name: string;
  role: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/**
 * Admin authentication API
 */
export const authApi = {
  /**
   * Login
   */
  async login(data: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/admin/auth/login', data);
    return response.data;
  },

  /**
   * Check if initial admin setup is needed
   */
  async getSetupStatus(): Promise<SetupStatusResponse> {
    const response = await api.get<SetupStatusResponse>('/admin/setup/status');
    return response.data;
  },

  /**
   * Create initial super admin
   */
  async createInitialAdmin(data: InitialAdminRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/admin/setup/initial-admin', data);
    return response.data;
  },

  /**
   * Get current admin profile
   */
  async getCurrentAdmin(): Promise<{ status: string; data?: AdminUser; message?: string }> {
    const response = await api.get<{ status: string; data?: AdminUser; message?: string }>(
      '/admin/me'
    );
    return response.data;
  },

  /**
   * Logout (client-side only, just clears token)
   */
  logout(): void {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
  },
};
